import Vue from "vue";

import fanyi from "@/utlis/language.js";

import fun from "@/utlis/CommonlyUsedFunctions.js";

let ps = {
  // --------------------------------------------data----------------------

  step: 1, //大的分页

  // nation 默认 Italia：意大利站注册，公司所在国家预填意大利
  formregister: { market_channel: [], country_phone: "+39", nation: "Italia" },

  inputRequireVer: {
    required: true,

    message: fanyi("此字段为必填项"),

    trigger: "blur",
  },

  Countdown: 60,

  // --------------------------------------------ref-----------------------

  PersonalDetails: null,

  Ocheck: null,

  VerificationCode: null,

  WelcomeVideo: null,

  registerBodyCarouselRef: null,

  //---------------------------------------------methods-------------------

  backLastPage() {
    if (ps.step == 1) {
      ps.PersonalDetails.goBack();
    } else if (ps.step == 2) {
      ps.Ocheck.goBack();
    } else if (ps.step == 3) {
      ps.VerificationCode.goBack();
    } else if (ps.step == 4) {
      ps.WelcomeVideo.goBack();
    }
  },

  goNext() {
    if (ps.step != 3) {
      ps.step++;
    } else {
      fun.routerToPage("/register-success");
    }
  },
};

export default ps;
